import React from 'react'
import CompanyCard from './CompanyCard'
// import { useTranslation } from 'react-i18next';


const CompaniesComponent = () => {
    // const { t } = useTranslation();
  
  return (
    <div className='container grid grid-cols-2 gap-[20px] max-[730px]:grid-cols-1'>
        <CompanyCard title='İkinci gəliş' description='2ci gəlişdə – ödənişsiz çay və şirniyyat☕'/>
        <CompanyCard title='Dördüncü gəliş' description='4cü gəlişdə – 2 x Popcorn🍿'/>
        <CompanyCard  title='Altıncı gəliş' description='6cı gəlişdə – ödənişsiz seans + 2 х🍿'/>
    </div>
  )
}

export default CompaniesComponent